import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faBars } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/UCS Prime Real Estate LLC Logo (1).png";
import logoScrolled from "../assets/UCS Prime Real Estate LLC Logo (1).png";
import "./Home/styles/Header.css";

// ...all imports remain same
function Navbar({ diffHeader = false }) {
  const [toggle, setToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navbarRef = useRef(null);

  const handleScroll = () => {
    setScrolled(window.scrollY > 100);
  };

  const handleDropdown = (type) => {
    setActiveDropdown((prev) => (prev === type ? null : type));
  };

  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setToggle(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const textColor = toggle
    ? "text-white"
    : scrolled || diffHeader
      ? "text-black"
      : "text-white";

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-200 ${diffHeader || scrolled
          ? "bg-white border-b border-gray-200"
          : "bg-transparent"
        }`}
    >
      <div className="flex items-center justify-between px-4 py-3 md:px-12">
        <div className="mx-10">
          <Link to="/">
            <img
              src={scrolled || diffHeader ? logoScrolled : logo}
              alt="logo"
              className="w-[66px] object-contain"
            />
          </Link>
        </div>

        <button
          className={`text-lg ${textColor} md:hidden`}
          onClick={() => setToggle(true)}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        <nav className="items-center justify-between hidden w-full md:flex">
          <div className="flex items-center gap-10"></div>

          <div className="flex items-center gap-10">
            {/*  <div className="relative dropdown group">
              <button
                onClick={() => handleDropdown("commercial")}
                className={` flex items-center dropbtn gap-1 text-lg ${textColor}`}
              >
                Commercial
              </button>

              <div className="absolute z-10 z-30 w-40 transition-all duration-200 bg-white rounded-md shadow-lg group-hover:opacity-100 dropdown-content">
                <NavLink
                  to="/commercialRealEstate"
                  className="block px-4 py-2 text-black hover:bg-gray-100"
                >
                  Buy Commercial
                </NavLink>
                <NavLink
                  to="/commercialRealEstate"
                  className="block px-4 py-2 text-black hover:bg-gray-100"
                >
                  Rent Commercial
                </NavLink>
              </div>
            </div>

            <div className="relative dropdown">
              <button
                className={`flex items-center gap-1 dropbtn text-lg ${textColor}`}
              >
                Residential
              </button>

              <div
                className="absolute z-30 w-40 bg-white rounded-md shadow-lg dropdown-content"
                aria-expanded="false"
              >
                <NavLink
                  to="/residentialRealEstate"
                  className="block px-4 py-2 text-black hover:bg-gray-100"
                >
                  Buy Residential
                </NavLink>
                <NavLink
                  to="/residentialRealEstate"
                  className="block px-4 py-2 text-black hover:bg-gray-100"
                >
                  Rent Residential
                </NavLink>
              </div>
            </div>
            */}
            <NavLink
              to="/commercialRealEstate"
              className={` text-lg ${textColor}`}
            >
              Commercial
            </NavLink>
            <NavLink
              to="/residentialRealEstate"
              className={` text-lg ${textColor}`}
            >
              Residential
            </NavLink>
            <NavLink to="/upcoming-properties" className={` text-lg ${textColor}`}>
              Off Plan
            </NavLink>
            <NavLink to="/aboutUs" className={` text-lg ${textColor}`}>
              About Us
            </NavLink>
            <NavLink to="/listProperty" className={` text-lg ${textColor}`}>
              List Property
            </NavLink>

            {/*<a
              href="https://wa.me/0528284121"
              className={`text-2xl ${textColor}-500!important `}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>*/}
          </div>
        </nav>
      </div>

      {toggle && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center text-white bg-black bg-opacity-95">
          <button
            className="absolute text-lg text-white top-6 right-6"
            onClick={() => setToggle(false)}
          >
            ✕
          </button>
          <nav
            ref={navbarRef}
            className="flex flex-col gap-10 text-lg font-semibold uppercase"
          >
            

            <NavLink
              to="/commercialRealEstate"
              className="hover:underline"
              onClick={() => setToggle(false)}
            >
              Commercial
            </NavLink>

            <NavLink
              to="/residentialRealEstate"
              className="hover:underline"
              onClick={() => setToggle(false)}
            >
              Residential
            </NavLink>

            <NavLink
              to="/upcoming-properties"
              className="hover:underline"
              onClick={() => setToggle(false)}
            >
              Off Plan
            </NavLink>

            <NavLink
              to="/aboutUs"
              className="hover:underline"
              onClick={() => setToggle(false)}
            >
              About Us
            </NavLink>

            <NavLink
              to="/listProperty"
              className="hover:underline"
              onClick={() => setToggle(false)}
            >
              List Property
            </NavLink>

         
          </nav>
        </div>
      )}

    </header>
  );
}

export default Navbar;
